import { Injectable } from '@angular/core'
import { UrlTree } from '@angular/router'
import { GbAuctionHomeUrlService } from 'libs/gb-front/auction/util/src/lib/gb-auction-home-url-service/gb-auction-home-url.service'
import { AuthFacade } from 'libs/gb-front/auth/data-access/src'
import { Observable, of, switchMap } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class GbVolGuard {
  constructor(private authFacade: AuthFacade, private gbAuctionHomeUrlService: GbAuctionHomeUrlService) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.authFacade.isVolunteer$.pipe(
      switchMap((isVolunteer) => (isVolunteer ? of(true) : this.gbAuctionHomeUrlService.homeUrlTree$)),
    )
  }
}
